import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import React from "react";
import { FilterProps } from "../../commons/filters/index.js";
import { FilterByOrganisationUsersButton } from "../users/FilterByOrganisationUsersButton.js";
import { useProductListsAuthorsQuery } from "./FilterByProductListAuthorsButton.generated.js";

/**
 * "Created by" filter for product lists: a `FilterByOrganisationUsersButton`
 * restricted to the users who actually authored a product list, so a large
 * organisation's full member list never shows up as filter options. Hidden
 * until the authors are known (and when no product list exists at all).
 */
export const FilterByProductListAuthorsButton = ({
  inputLabel,
  placeholder,
  ...props
}: FilterProps<string[]> & {
  inputLabel: string;
  placeholder: string;
}) => {
  const client = useApolloClient();
  const query = useProductListsAuthorsQuery({ client });
  const authorIds = getDataOrNull(
    (query.data ?? query.previousData)?.productListsAuthors
  )?.authorIds;

  if (!authorIds || authorIds.length === 0) return null;

  return (
    <FilterByOrganisationUsersButton
      inputLabel={inputLabel}
      placeholder={placeholder}
      filters={{ ids: authorIds }}
      {...props}
    />
  );
};
